// extracted by extract-css-chunks-webpack-plugin
module.exports = {"td-row-selector":"styles__td-row-selector--23Dxg","tdRowSelector":"styles__td-row-selector--23Dxg"};